import { Box } from '@mui/material'
import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2'
import styles from './Chart.module.css'

ChartJS.register(ArcElement, Tooltip, Legend);

function ChartDonut({ type, inform, total }) {

  let dataChart = []
  let status_chart = []
  let backgroundColor = []
  let borderColor = []
  let idChart = ''

  const setBg = (index) => {
    //ซุ่มสีปกติ
    // const randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
    // return randomColor

    //ซุ่มสีพาลเทล
    // return `hsla(${~~(360 * Math.random())}, 70%,  72%, 0.8)`

    let color = ['#CEC2EB', '#FFB6B9', '#8AC6D1', '#F9BCDD', '#FFF1AC', '#D5A4CF', '#FDC4B6', '#7F95D1', '#95E1D3', '#D4EDF4', '#E9BBA9', '#C08497']
    // let index = Math.floor(Math.random() * color.length);
    return color[index]
  }

  switch (type) {
    case "group":
      {
        inform.map((i, idx) => (
          status_chart.push({
            'label': i['group_name'],
            'color': setBg(idx)
          }),
          dataChart.push(
            i['total']
          )
        ))
      }
      if (dataChart.length === 0) {
        dataChart = [1]
        backgroundColor = ['#D9D9D9']
        borderColor = ['#D9D9D9']
      } else {
        {
          status_chart.map(i => (
            backgroundColor.push(i['color']),
            borderColor.push(i['color'])
          ))
        }
      }
      idChart = "group"
      break;

    case "status":
      {
        inform.map((i, idx) => (
          status_chart.push({
            'label': i['group_name'],
            'color': setBg(idx)
          }),
          dataChart.push(
            i['total']
          )
        ))
      }
      if (dataChart.length === 0) {
        dataChart = [1]
        backgroundColor = ['#D9D9D9']
        borderColor = ['#D9D9D9']
      } else {
        {
          status_chart.map(i => (
            backgroundColor.push(i['color']),
            borderColor.push(i['color'])
          ))
        }
      }
      idChart = "status"
      break;

    default:
  }

  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        display: false
      },
      legend: {
        display: false
      },
      title: {
        display: false
      },
      tooltip: {
        bodyFont: {
          family: 'IBM Plex Sans Thai', // เปลี่ยนตรงนี้เป็น font family ที่ต้องการ
        },
        titleFont: {
          family: 'IBM Plex Sans Thai',
        },
        callbacks: {
          label: ((context) => {
            let id = type
            const dataIndexValue = context.formattedValue
            const percent = (dataIndexValue / total) * 100
            const dataPercent = dataIndexValue + (id === 'group' ? ' รายการ ' : ' คน ') + '(' + percent.toFixed(2) + '%)'
            return dataPercent
          }),
        }
      },
      pluginsOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                fontSize: 50,
                color: '#000'
              }
            }
          }
        }
      }
    }
  };

  const labelShow = () => {
    let x = []
    {
      status_chart.map(i => (
        x.push(i['label'])
      ))
    }
    return x
  }

  const data = {
    labels: labelShow(),
    datasets: [
      {
        data: dataChart,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: 1,
        cutout: '70%'
      },
    ],
  };

  return (
    <Box className={styles.contentChart}>
      <Box className={styles.donutContent}>
        <Doughnut
          data={data}
          options={options}
        />
        <Box className={styles.textTotal}>
          <Box>N = {total} {idChart == 'group' ? 'รายการ' : 'คน'}</Box>
        </Box>
      </Box>
      <Box className={styles.contentLegend}>
        <Box>
          {status_chart.map((item, index) => (
            <Box key={`${idChart}_${index}`} className={styles.Legend}>
              <Box className={styles.dotLegend} style={{ backgroundColor: item['color'] }}></Box>
              <p>{item['label']}</p>
            </Box>
          ))}
        </Box>
      </Box>

    </Box>
  )
}

export default ChartDonut
